module.exports = __webpack_public_path__ + "img/activity.2c4d57e4.png";